import React from "react";
import { BiSearch } from "react-icons/bi";
import { MdOutlineSearch } from "react-icons/md";
import { RiMenuSearchFill } from "react-icons/ri";
import { Icon, Input } from "semantic-ui-react";
import ListSelect from "./listSelect";
import { useNavigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import Roulette from "../../images/EventListSelect/active_04.webp";
import { COMMON_ALT } from "../../constant";

const MobileSearch = ({ listHidden }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const navigate = useNavigate();
  const { gamePlatform } = useParams();

  return (
    <section className="flex flex-col gap-[8px] px-common-padding-y mb-[20px]">
      <section className="flex items-center gap-[8px] h-[44px]">
        <div
          onClick={() => {
            navigate("search");
          }}
          className="min-w-[44px] h-full max-w-[44px] flex items-center justify-center rounded-[5px] bg-base-deep-gray dark:bg-base-light-dark"
        >
          <MdOutlineSearch className="text-3xl text-base-gray dark:text-base-white" />
        </div>
        {/* <div
          onClick={() => {
            navigate("roulette");
          }}
          className="min-w-[44px] h-full max-w-[44px] flex items-center justify-center rounded-[5px] bg-base-deep-gray dark:bg-base-light-dark"
        >
          <img
            src={Roulette}
            className="cursor-pointer min-w-[44px] h-full max-w-[44px] flex items-center justify-center rounded-[5px] bg-base-deep-gray dark:bg-base-light-dark"
            alt={COMMON_ALT}
          />
        </div> */}
        <div
          onClick={() => {
            navigate("casino-group");
          }}
          className="w-full h-full bg-base-light-white dark:bg-base-light-dark rounded-[5px] px-[10px] flex items-center justify-between text-base-gray dark:text-base-white"
        >
          <span>
            {gamePlatform && gamePlatform !== "all"
              ? gamePlatform
              : i18n("All providers")}
          </span>
          <RiMenuSearchFill className="text-3xl" />
        </div>
      </section>
      <section>{listHidden || <ListSelect />}</section>
    </section>
  );
};

export default MobileSearch;
